const AboutCoreValue = () => {
  return (
    <section className="roadmap roadmap--style1 padding-top padding-bottom bg-color py-5" id="roadmap">
      <div className="container">
        <div className="section-header w-75 m-auto text-center">
          <h2 className="mb-10 mt-minus-5 mb-4">OUR GUIDING PRINCIPLES <span className="style2"> & CORE VALUES</span></h2>
        </div>
        
        {/* Guiding Principles & Core Values Section */}
        <div className="principles-section">
          <div className="principles-list">
            <div className="principle-item">
              <h3><span className="principle-number">1</span>Customer interest is paramount</h3>
           </div>
            <div className="principle-item">
              <h3><span className="principle-number">2</span>Ethical and transparent business practices</h3>
            </div>
            <div className="principle-item">
              <h3><span className="principle-number">3</span>Respect for professionals, associates and business partners</h3>
             </div>
            <div className="principle-item">
              <h3><span className="principle-number">4</span>Research based value investing</h3>
            </div>
            <div className="principle-item">
              <h3><span className="principle-number">5</span>Cutting edge technology to ensure world-class customer service</h3>
            </div>
          </div>
        </div>
      </div>
  
    </section>
  );
};

export default AboutCoreValue;